var _g, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 40,
    viewBox: "0 0 71 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_3029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18C4 9.16344 11.1634 2 20 2H51C59.8366 2 67 9.16344 67 18C67 26.8366 59.8366 34 51 34H20C11.1634 34 4 26.8366 4 18Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.217 11.314V14.525H40.877V15.396H43.217V19.855H44.296V11.314H43.217ZM41.033 18.1L41.566 17.268C39.876 16.683 38.732 15.201 38.732 13.693V13.121H41.293V12.25H35.066V13.121H37.666V13.706C37.666 15.357 36.457 16.904 34.728 17.528L35.287 18.36C36.652 17.853 37.718 16.813 38.225 15.461C38.732 16.657 39.733 17.632 41.033 18.1ZM44.621 22.702V21.831H37.913V19.101H36.834V22.702H44.621ZM55.554 22.949V11.301H54.527V22.949H55.554ZM53.201 11.574H52.187V15.903H50.406V16.787H52.187V22.351H53.201V11.574ZM49.041 14.889V14.33H51.199V13.446H49.054V11.717H48.027V13.446H45.869V14.33H48.027V14.889C48.027 16.8 47.13 18.841 45.557 19.777L46.181 20.57C47.325 19.881 48.144 18.62 48.547 17.099C48.976 18.503 49.795 19.686 50.939 20.323L51.55 19.517C49.977 18.685 49.041 16.748 49.041 14.889Z",
    fill: "#282D4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8334 11.8333H21.5V17.5H15.8334V11.8333ZM16.8334 12.8333V16.5H20.5V12.8333H16.8334Z",
    fill: "#282D4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8334 18.5H21.5V24.1667H15.8334V18.5ZM16.8334 19.5V23.1667H20.5V19.5H16.8334Z",
    fill: "#282D4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 11.8333H28.1667V17.5H22.5V11.8333ZM23.5 12.8333V16.5H27.1667V12.8333H23.5Z",
    fill: "#282D4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 18.5H28.1667V24.1667H22.5V18.5ZM23.5 19.5V23.1667H27.1667V19.5H23.5Z",
    fill: "#282D4B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_3029",
    x: 0,
    y: 0,
    width: 71,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_3029"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_3029",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUAll);
export default __webpack_public_path__ + "static/media/u_all.690ac8bb6702df0105b66876c8ae3cb3.svg";
export { ForwardRef as ReactComponent };